import * as React from 'react';
import { Loader } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useAddToCart } from '../../../hooks/use-add-to-cart.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/create-cart-from-order.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '../../../context/CartSettings/context.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../utils/get-validation-errors-by-line-item.js';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/analytics';
import '@grandvisionhq/payments';
import '../../../mappers/analytics/tealium/line-item-to-tealium-product.js';
import '../../../context/Cart/context.js';
import { AddButton } from '../components/AddButton.js';
import '@grandvisionhq/icons';
import '@grandvisionhq/elements';

const AddButtonContainer = ({ lineItemDrafts , onSuccess  })=>{
    const { getLabel  } = useIntl();
    const [addToCart, { loading  }] = useAddToCart();
    const labels = React.useMemo(()=>({
            addToCart: getLabel('cart.actions.addToCart')
        })
    , [
        getLabel
    ]);
    const handOnClick = React.useCallback(()=>addToCart(lineItemDrafts, onSuccess)
    , [
        addToCart,
        lineItemDrafts,
        onSuccess
    ]);
    return loading ? /*#__PURE__*/ React.createElement(Loader, {
        className: "add-button__loader"
    }) : /*#__PURE__*/ React.createElement(AddButton, {
        caption: labels.addToCart,
        onClick: handOnClick
    });
};

export { AddButtonContainer };
//# sourceMappingURL=AddButtonContainer.js.map
